import reqest from "../common/reqest";


/**
 * 绑定用户
 * @param data
 * @returns {Promise<unknown>}
 */
export function setBind(data) {
  return reqest.send("/Gateway/Bind_user", data)
}


/**
 * 进入直播间
 * @param data
 * @returns {Promise<unknown>}
 */
export function goRoom(data) {
  return reqest.send("/Gateway/Go_Room", data)
}

/**
 * 排队接口
 * @param data
 * @returns {Promise<unknown>}
 */
export function getWait(data) {
  return reqest.send("/Gateway/Broadcast_Queue", data)
}

/**
 * 弹窗进入直播间
 * @param data
 * @returns {Promise<unknown>}
 */
export function getDialogJoin(data) {
  return reqest.send("/Gateway/Queue_Alert", data)
}


/**
 * 弹窗不进入
 * @param data
 * @returns {Promise<unknown>}
 */
export function getNotEnter(data) {
  return reqest.send("/Gateway/Queue_Alert", data)
}

/**
 * 弹窗不进入
 * @param data
 * @returns {Promise<unknown>}
 */
export function notJoinRoom(data) {
  return reqest.send("/Gateway/not_join_room", data)
}


/**
 * 离开直播间
 * @param data
 * @returns {Promise<unknown>}
 */
export function exit(data) {
  return reqest.send("/Gateway/Live_User_Leave", data)
}

